
import SEOHead from '../../components/seo/SEOHead';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import StatsSection from './components/StatsSection';
import TrustSection from './components/TrustSection';

export default function Home() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "顺年陈",
    "description": "顺年陈专注高端年份普洱茶，是行业革新者与引领者。以透明化体系、数据化标准、可视化体验，重构年份茶行业生态。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
    "logo": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/logo.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+86-400-123-4567",
      "contactType": "customer service",
      "availableLanguage": "Chinese"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "CN",
      "addressLocality": "云南省",
      "addressRegion": "昆明市"
    },
    "sameAs": [
      "https://weibo.com/shuniancheng",
      "https://www.xiaohongshu.com/shuniancheng"
    ]
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="顺年陈 - 新一代年份茶的标准制定者与引领者"
        description="顺年陈专注高端年份普洱茶，是行业革新者与引领者。以透明化体系、数据化标准、可视化体验，重构年份茶行业生态。三真承诺：真产地、真年份、真转化。"
        keywords="顺年陈,年份茶,普洱茶,高端茶叶,茶叶品牌,云南茶叶"
        canonical="/"
        structuredData={structuredData}
      />
      <HeroSection />
      <StatsSection />
      <ProductsSection />
      <TrustSection />
    </div>
  );
}
